module.exports = __webpack_public_path__ + "img/yu_5.377a424b.png";